import * as React from "react";
import "./style.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {fetchETLs, fetchFacilities, setFacilities} from "../../../redux/models/integrations/Action";
import Facility from "./Facility";
import {isEmpty} from "weed-js";
import Loading from "../../../components/elements/Loading";
import {enqueueSnackbar} from "../../../redux/Actions";
import {
    Table, TableBody, TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import Quotas from "./Quotas";

const Facilities = ({
    integrationAccount,
    loggedInUser,
    integrationNamespace
}) => {
    const facilities = useSelector(state => {
        const acct = state.integrationReducer.accounts[integrationNamespace].find(account => account.id === integrationAccount?.id) || [];
        if (isEmpty(acct)) {
            return [];
        }
        return acct.facilities || [];
    });
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [etls, setETLs] = useState([]);
    const [manageQuotas, setManageQuotas] = useState({});
    
    useEffect(() => {
        const abortController = new AbortController();
        dispatch(fetchFacilities(integrationNamespace, integrationAccount?.id, {}, abortController)).then((fetchedFacilities) => {
            dispatch(setFacilities(integrationNamespace, fetchedFacilities));
            setManageQuotas(fetchedFacilities.reduce((acc, facility) => {
                acc[facility.id] = false;
                return acc;
            }, {}));
            dispatch(fetchETLs({namespace: integrationNamespace})).then(fetchedETLs => {
                setETLs(fetchedETLs);
            });
            setIsLoading(false);
            if (isEmpty(fetchedFacilities)) {
                setFacilities(integrationNamespace, []);
                dispatch(enqueueSnackbar({
                    message: "No facilities found for this account",
                    options: {
                        variant: "info"
                    }
                }));
            }
        }).catch(err => {
            setIsLoading(false);
            dispatch(setFacilities(integrationNamespace, []));
            if (!isEmpty(err)) {

                dispatch(enqueueSnackbar({
                    message: "Failed to fetch facilities. Are you an account admin?",
                    options: {
                        variant: "error"
                    }
                }));
            }
        });
        return () => {
            abortController.abort();
        };
    }, [integrationAccount?.id]);

    if (isLoading) {
        return <Loading/>;
    }

    const quotas = <>{facilities.map(facility => <Quotas
        integrationAccount={integrationAccount}
        loggedInUser={loggedInUser}
        integrationNamespace={integrationNamespace}
        key={facility.id}
        etls={etls}
        facility={facility}
        manageQuotas={manageQuotas}
        setManageQuotas={setManageQuotas}
    />)}</>;


    return <div>
        {quotas}
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>License</TableCell>
                        <TableCell>License Type</TableCell>
                        <TableCell>Contact Email</TableCell>
                        <TableCell>Inception Date</TableCell>
                        <TableCell>Active</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {facilities.map(facility => <Facility
                        integrationAccount={integrationAccount}
                        loggedInUser={loggedInUser}
                        integrationNamespace={integrationNamespace}
                        key={facility.id}
                        etls={etls}
                        facility={facility}
                        manageQuotas={manageQuotas}
                        setManageQuotas={setManageQuotas}
                    />)}
                </TableBody>
            </Table>
        </TableContainer>;
    </div>;

};

export default Facilities;